import React from 'react';

export type WidgetType =
  | 'incident_map'
  | 'devices_map'
  | 'devices_list_table'
  | 'devices_list_map'
  | 'devices_list'
  | 'files_list'
  | 'incidents_list'
  | 'claimed_devices'
  | 'online_devices'
  | 'active_incidents'
  | 'note'
  | 'space_incidents_rate'
  | 'device_incidents_rate'
  // TODO: Legacy widgets - remove when legacy widgets are fully deprecated
  | 'devices_overview_modern'
  | 'incident_summary_modern'
  | 'top_spaces_with_incidents'
  | 'top_incidents'
  | 'devices_by_model_in_space';

export interface DashboardComponent {
  id: WidgetType;
  name: string;
  description: string;
  Component: React.ComponentType<{
    widgetId?: string;
    closeModal?: () => void;
  }>;
  thumbnail: string | null;
  icon: string | null;
  withSettings?: boolean;
  minW?: number;
  minH?: number;
  maxW?: number;
  maxH?: number;
  h?: number;
  w?: number;
  isLegacy?: boolean;
}

export enum DataLevelEnum {
  All = 'all',
  Local = 'local',
}

export type LayoutBreakpoint = 'lg' | 'md' | 'sm' | 'xs' | 'xxs';
